module.exports = require("redux");


//////////////////
// WEBPACK FOOTER
// external "redux"
// module id = 384
// module chunks = 0